import RootView from './RootView';
import type { IToast, IToastMessage } from './interface';
import { dispatchAction, getStore } from './store';
import actions from './actions';
import { nanoid } from '@reduxjs/toolkit';

const DEFAULT_DURATION = 5000;

export function isShowing(message: Partial<IToastMessage>) {
    const store = getStore();

    const results = message.id
        ? store.filter(item => (message.id && item.id ? message.id === item.id : true))
        : store.filter(item => item.text === message.text);

    return results.length > 0;
}

function toaster(): IToast {
    return {
        renderer: RootView,
        show: (message: IToastMessage, duration?: number) => {
            const actionMessage = {
                ...message,
                id: message.id ?? nanoid(),
            };
            dispatchAction(actions.displayMessage(actionMessage));

            setTimeout(
                () => dispatchAction(actions.hideMessage(actionMessage)),
                duration ?? DEFAULT_DURATION,
            );
        },
        hide: (message: Partial<IToastMessage>) => dispatchAction(actions.hideMessage(message)),
        message: (id: string) => getStore().filter(item => item.id === id)[0],
        isShowing,
    };
}

export default toaster;
